import React from 'react';
import MainTitle from '../../components/MainTitle/index';
import Header from '../../components/Header/index';
import { LockIcon } from '../../components/Icon/index';

const AccessDeniedPage = () => (
  <>
    <Header>
      <MainTitle>
        <LockIcon />
        {' '}
Access denied
      </MainTitle>
    </Header>
  </>
);

export default AccessDeniedPage;
